import { AuthenService } from './../../services/authen.service';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, CanActivateChild } from "@angular/router";
import { Observable } from "rxjs/Rx";
import { TranslateService } from '@ngx-translate/core';
import { PermissionService } from '../../services/permission.service';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
    currentUser: any;
    currentLanguage: string;
    constructor(private _router: Router,
        public _authService: AuthenService,
        public translate: TranslateService,
        public _permissionService: PermissionService) {
        this.setLanguage();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));


        let URlRedirect = state.url;
        if (state.url) {
            if (state.url.indexOf('?') > -1) {
                URlRedirect = state.url.split('?')[0];
            }
        }

        if (this.currentUser) {
            return this._authService.verify().pipe(
                tap((isValidToken: boolean) => {
                    if (!this.checkCanAccessUrl(URlRedirect)) {
                        this._router.navigate(['/not-authorized']);
                        return of(false);
                    }

                    if(!isValidToken) {
                        this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                        return of(false);
                    }
                    return of(true);
                }),
                catchError(err => {
                    console.log('Handling error locally and rethrowing it...', err);
                    this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                    return of(false);
                })
            );
        }
        else {
            this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        return true;
    }

    setLanguage() {
        this.currentLanguage = localStorage.getItem('Language');
        if (this.currentLanguage !== null && this.currentLanguage !== '') {
            this.translate.use(this.currentLanguage);
        } else {
            this.translate.use('en');
        }
    }

    checkCanAccessUrl = (url: string): boolean => {
        return this._permissionService.CheckCanAccessURL(url);
    }
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
           // this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}